import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route, Navigate, useLocation, useParams } from 'react-router-dom';
import './i18n';
import { useTranslation } from 'react-i18next';

import Header from './components/Header';
import Footer from './components/Footer';
import CookieBanner from './components/CookieBanner';
import ScrollToTop from './components/ScrollToTop';

import HomePage from './pages/HomePage';
import PrivacyPage from './pages/PrivacyPage';
import CookiePolicyPage from './pages/CookiePolicyPage';
import TermsPage from './pages/TermsPage';
import ThankYouPage from './pages/ThankYouPage';

const SUPPORTED = ['ar', 'en'];

function LangShell({ children }) {
  const { lang } = useParams();
  const { i18n } = useTranslation();
  useEffect(() => {
    if (SUPPORTED.includes(lang) && i18n.language !== lang) {
      i18n.changeLanguage(lang);
      document.documentElement.lang = lang === 'ar' ? 'es-AR' : 'en';
    }
  }, [lang, i18n]);

  if (!SUPPORTED.includes(lang)) return <Navigate to="/ar" replace />;
  return children;
}

function ThankYouShell() {
  const { i18n } = useTranslation();
  useEffect(() => {
    if (i18n.language !== 'ar') {
      i18n.changeLanguage('ar');
      document.documentElement.lang = 'es-AR';
    }
  }, [i18n]);
  return <ThankYouPage />;
}

function TitleUpdater() {
  const { t, i18n } = useTranslation();
  const location = useLocation();
  useEffect(() => {
    document.title = t('meta.title');
    let meta = document.querySelector('meta[name="description"]');
    if (meta) meta.setAttribute('content', t('meta.description'));
  }, [t, i18n.language, location.pathname]);
  return null;
}

function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <TitleUpdater />
      <Routes>
        <Route path="/" element={<Navigate to="/ar" replace />} />
        <Route path="/thank_you" element={<ThankYouShell />} />
        <Route
          path="/:lang"
          element={
            <LangShell>
              <SiteLayout><HomePage /></SiteLayout>
            </LangShell>
          }
        />
        <Route
          path="/:lang/privacy"
          element={
            <LangShell>
              <SiteLayout><PrivacyPage /></SiteLayout>
            </LangShell>
          }
        />
        <Route
          path="/:lang/cookies"
          element={
            <LangShell>
              <SiteLayout><CookiePolicyPage /></SiteLayout>
            </LangShell>
          }
        />
        <Route
          path="/:lang/terms"
          element={
            <LangShell>
              <SiteLayout><TermsPage /></SiteLayout>
            </LangShell>
          }
        />
        <Route path="*" element={<Navigate to="/ar" replace />} />
      </Routes>
    </BrowserRouter>
  );
}

function SiteLayout({ children }) {
  return (
    <>
      <Header />
      <main>{children}</main>
      <Footer />
      <CookieBanner />
    </>
  );
}

export default App;
